"use strict";
// Ported from Solidity:
// // https://github.com/balancer-labs/balancer-v2-monorepo/blob/589542001aeca5bdc120404874fe0137f6a4c749/pkg/pool-linear/contracts/LinearMath.sol
Object.defineProperty(exports, "__esModule", { value: true });
exports._calcWrappedOutPerBptIn = exports._calcWrappedInPerBptOut = exports._calcBptInPerWrappedOut = exports._calcBptOutPerWrappedIn = exports._calcMainInPerWrappedOut = exports._calcMainOutPerWrappedIn = exports._calcMainOutPerBptIn = exports._calcMainInPerBptOut = exports._calcWrappedInPerMainOut = exports._calcWrappedOutPerMainIn = exports._calcBptInPerMainOut = exports._calcBptOutPerMainIn = void 0;
const fp = require("../../utils/math/fixed-point");
const math = require("../../utils/math/math");
const _calcBptOutPerMainIn = (mainIn, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount out, so we round down overall.
    if (bptSupply.isZero()) {
        return _toNominal(mainIn, params);
    }
    const previousNominalMain = _toNominal(mainBalance, params);
    const afterNominalMain = _toNominal(fp.add(mainBalance, mainIn), params);
    const deltaNominalMain = fp.sub(afterNominalMain, previousNominalMain);
    const invariant = _calcInvariantUp(previousNominalMain, wrappedBalance, params);
    return fp.divDown(fp.mulDown(bptSupply, deltaNominalMain), invariant);
};
exports._calcBptOutPerMainIn = _calcBptOutPerMainIn;
const _calcBptInPerMainOut = (mainOut, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount in, so we round up overall.
    const previousNominalMain = _toNominal(mainBalance, params);
    const afterNominalMain = _toNominal(fp.sub(mainBalance, mainOut), params);
    const deltaNominalMain = fp.sub(previousNominalMain, afterNominalMain);
    const invariant = _calcInvariantDown(previousNominalMain, wrappedBalance, params);
    return fp.divUp(fp.mulUp(bptSupply, deltaNominalMain), invariant);
};
exports._calcBptInPerMainOut = _calcBptInPerMainOut;
const _calcWrappedOutPerMainIn = (mainIn, mainBalance, params) => {
    // Amount out, so we round down overall.
    const previousNominalMain = _toNominal(mainBalance, params);
    const afterNominalMain = _toNominal(fp.add(mainBalance, mainIn), params);
    const deltaNominalMain = fp.sub(afterNominalMain, previousNominalMain);
    return fp.divDown(deltaNominalMain, params.rate);
};
exports._calcWrappedOutPerMainIn = _calcWrappedOutPerMainIn;
const _calcWrappedInPerMainOut = (mainOut, mainBalance, params) => {
    // Amount in, so we round up overall.
    const previousNominalMain = _toNominal(mainBalance, params);
    const afterNominalMain = _toNominal(fp.sub(mainBalance, mainOut), params);
    const deltaNominalMain = fp.sub(previousNominalMain, afterNominalMain);
    return fp.divUp(deltaNominalMain, params.rate);
};
exports._calcWrappedInPerMainOut = _calcWrappedInPerMainOut;
const _calcMainInPerBptOut = (bptOut, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount in, so we round up overall.
    if (bptSupply.isZero()) {
        return _fromNominal(bptOut, params);
    }
    const previousNominalMain = _toNominal(mainBalance, params);
    const invariant = _calcInvariantUp(previousNominalMain, wrappedBalance, params);
    const deltaNominalMain = fp.divUp(fp.mulUp(invariant, bptOut), bptSupply);
    const afterNominalMain = fp.add(previousNominalMain, deltaNominalMain);
    const newMainBalance = _fromNominal(afterNominalMain, params);
    return fp.sub(newMainBalance, mainBalance);
};
exports._calcMainInPerBptOut = _calcMainInPerBptOut;
const _calcMainOutPerBptIn = (bptIn, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount out, so we round down overall.
    const previousNominalMain = _toNominal(mainBalance, params);
    const invariant = _calcInvariantDown(previousNominalMain, wrappedBalance, params);
    const deltaNominalMain = fp.divDown(fp.mulDown(invariant, bptIn), bptSupply);
    const afterNominalMain = fp.sub(previousNominalMain, deltaNominalMain);
    const newMainBalance = _fromNominal(afterNominalMain, params);
    return fp.sub(mainBalance, newMainBalance);
};
exports._calcMainOutPerBptIn = _calcMainOutPerBptIn;
const _calcMainOutPerWrappedIn = (wrappedIn, mainBalance, params) => {
    // Amount out, so we round down overall.
    const previousNominalMain = _toNominal(mainBalance, params);
    const deltaNominalMain = fp.mulDown(wrappedIn, params.rate);
    const afterNominalMain = fp.sub(previousNominalMain, deltaNominalMain);
    const newMainBalance = _fromNominal(afterNominalMain, params);
    return fp.sub(mainBalance, newMainBalance);
};
exports._calcMainOutPerWrappedIn = _calcMainOutPerWrappedIn;
const _calcMainInPerWrappedOut = (wrappedOut, mainBalance, params) => {
    // Amount in, so we round up overall.
    const previousNominalMain = _toNominal(mainBalance, params);
    const deltaNominalMain = fp.mulUp(wrappedOut, params.rate);
    const afterNominalMain = fp.add(previousNominalMain, deltaNominalMain);
    const newMainBalance = _fromNominal(afterNominalMain, params);
    return fp.sub(newMainBalance, mainBalance);
};
exports._calcMainInPerWrappedOut = _calcMainInPerWrappedOut;
const _calcBptOutPerWrappedIn = (wrappedIn, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount out, so we round down overall.
    if (bptSupply.isZero()) {
        // Return nominal DAI
        return fp.mulDown(wrappedIn, params.rate);
    }
    const nominalMain = _toNominal(mainBalance, params);
    const previousInvariant = _calcInvariantUp(nominalMain, wrappedBalance, params);
    const newWrappedBalance = fp.add(wrappedBalance, wrappedIn);
    const newInvariant = _calcInvariantDown(nominalMain, newWrappedBalance, params);
    const newBptBalance = fp.divDown(fp.mulDown(bptSupply, newInvariant), previousInvariant);
    return fp.sub(newBptBalance, bptSupply);
};
exports._calcBptOutPerWrappedIn = _calcBptOutPerWrappedIn;
const _calcBptInPerWrappedOut = (wrappedOut, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount in, so we round up overall.
    const nominalMain = _toNominal(mainBalance, params);
    const previousInvariant = _calcInvariantUp(nominalMain, wrappedBalance, params);
    const newWrappedBalance = fp.sub(wrappedBalance, wrappedOut);
    const newInvariant = _calcInvariantDown(nominalMain, newWrappedBalance, params);
    const newBptBalance = fp.divDown(fp.mulDown(bptSupply, newInvariant), previousInvariant);
    return fp.sub(bptSupply, newBptBalance);
};
exports._calcBptInPerWrappedOut = _calcBptInPerWrappedOut;
const _calcWrappedInPerBptOut = (bptOut, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount in, so we round up overall.
    if (bptSupply.isZero()) {
        // Return nominal DAI
        return fp.divUp(bptOut, params.rate);
    }
    const nominalMain = _toNominal(mainBalance, params);
    const previousInvariant = _calcInvariantUp(nominalMain, wrappedBalance, params);
    const newBptBalance = fp.add(bptSupply, bptOut);
    const newWrappedBalance = fp.divUp(fp.sub(fp.mulUp(fp.divUp(newBptBalance, bptSupply), previousInvariant), nominalMain), params.rate);
    return fp.sub(newWrappedBalance, wrappedBalance);
};
exports._calcWrappedInPerBptOut = _calcWrappedInPerBptOut;
const _calcWrappedOutPerBptIn = (bptIn, mainBalance, wrappedBalance, bptSupply, params) => {
    // Amount out, so we round down overall.
    const nominalMain = _toNominal(mainBalance, params);
    const previousInvariant = _calcInvariantUp(nominalMain, wrappedBalance, params);
    const newBptBalance = fp.sub(bptSupply, bptIn);
    const newWrappedBalance = fp.divUp(fp.sub(fp.mulUp(fp.divUp(newBptBalance, bptSupply), previousInvariant), nominalMain), params.rate);
    return fp.sub(wrappedBalance, newWrappedBalance);
};
exports._calcWrappedOutPerBptIn = _calcWrappedOutPerBptIn;
const _calcInvariantUp = (nominalMainBalance, wrappedBalance, params) => {
    return fp.add(nominalMainBalance, fp.mulUp(wrappedBalance, params.rate));
};
const _calcInvariantDown = (nominalMainBalance, wrappedBalance, params) => {
    return fp.add(nominalMainBalance, fp.mulDown(wrappedBalance, params.rate));
};
const _toNominal = (amount, params) => {
    if (amount.lt(fp.mulUp(math.sub(fp.ONE, params.fee), params.lowerTarget))) {
        return fp.divUp(amount, math.sub(fp.ONE, params.fee));
    }
    else if (amount.lt(math.sub(params.upperTarget, fp.mulUp(params.fee, params.lowerTarget)))) {
        return fp.add(amount, fp.mulUp(params.fee, params.lowerTarget));
    }
    else {
        return fp.divUp(fp.add(amount, fp.mulUp(math.add(params.lowerTarget, params.upperTarget), params.fee)), math.add(fp.ONE, params.fee));
    }
};
const _fromNominal = (nominal, params) => {
    if (nominal.lt(params.lowerTarget)) {
        return fp.mulUp(nominal, math.sub(fp.ONE, params.fee));
    }
    else if (nominal.lt(params.upperTarget)) {
        return fp.sub(nominal, fp.mulUp(params.fee, params.lowerTarget));
    }
    else {
        return fp.sub(fp.mulUp(nominal, math.add(fp.ONE, params.fee)), fp.mulUp(params.fee, math.add(params.lowerTarget, params.upperTarget)));
    }
};
